import type { UserListQueryVariables } from 'graphql/generated'
import { buildPersonSearchPatterns, normalizePersonSearchText } from 'lib/person-search'

type AddTenantSearchQueryArgs = {
  variables: UserListQueryVariables
  pause: boolean
}

export const buildAddTenantSearchQueryArgs = (searchText: string): AddTenantSearchQueryArgs => {
  const normalizedSearchText = normalizePersonSearchText(searchText)
  const pause = normalizedSearchText.length < 2
  const patterns = buildPersonSearchPatterns(searchText)

  return {
    variables: {
      where: pause
        ? {}
        : {
            deleted_at: { _is_null: true },
            _or: [
              { user_searchable: { info: { _ilike: patterns.combined } } },
              { first_name: { _ilike: patterns.singleField } },
              { last_name: { _ilike: patterns.singleField } },
              { email: { _ilike: patterns.singleField } },
              ...(patterns.hasLastName
                ? [
                    {
                      _and: [
                        { first_name: { _ilike: patterns.firstName } },
                        { last_name: { _ilike: patterns.lastName } }
                      ]
                    }
                  ]
                : [])
            ]
          }
    },
    pause
  }
}
